/**
 * 2026-04-25: 무기·방어구·장신구 이모지 아이콘 헬퍼.
 *   RefineModal / EngraveCeremonyModal 등 공유.
 *   tag 우선 (검·도끼·창·활 등), 없으면 category 폴백.
 */
import type { InventoryItemView } from "@/api/types";

export function equipmentIcon(item: InventoryItemView): string {
    const def = item.definition;
    if (!def) return "⚒";
    const tags = def.tags ?? [];
    if (tags.includes("sword")) return "🗡";
    if (tags.includes("axe")) return "🪓";
    if (tags.includes("spear") || tags.includes("polearm")) return "🔱";
    if (tags.includes("bow")) return "🏹";
    if (tags.includes("dagger")) return "🗡";
    if (tags.includes("staff") || tags.includes("caster-staff")) return "🪄";
    if (tags.includes("focus") || tags.includes("caster-focus")) return "🔮";
    const cat = def.category;
    if (cat === "WEAPON") return "🗡";
    if (cat === "ARMOR") return "🛡";
    if (cat === "ACCESSORY") return "💍";
    if (cat === "CHARM") return "✨";
    return "⚒";
}
